import React, { Component } from 'react'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { Layout, NavDrawer, Panel, Sidebar } from 'react-toolbox/lib/layout'
import T from 'i18n-react'

import {
  NVBUGS_CARD,
} from 'containers/Manage/Nvbugs/NvbugsCard/constants'

import {
  NVBUGS,
  NAVIGATIONS_LIST
} from './constants'

import nvbugsCardSagas from 'containers/Manage/Nvbugs/NvbugsCard/sagas'
import nvbugsSagas from './sagas'

import Heading from './Heading'
import CSSModules from 'helpers/CSSModulesUtil'
import injectSagas from 'helpers/injectSagas'
import MainPanel from './MainPanel'

import Link from './Link'
import List from './List'
import styles from './styles.scss'

import {
  mount,
  unmount
} from './actions'

const mapStateToProps = (state) => {
  return {
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    mount: () => dispatch(mount()),
    unmount: () => dispatch(unmount())
  }
}

class NvbugsPage extends Component {
  componentWillMount() {
    this.props.mount()
  }

  componentWillUnmount() {
    this.props.unmount()
  }
  
  render() {

    const navigationListComponents = NAVIGATIONS_LIST.map(({label, to}, idx) =>
      <List key={idx}>
        <Link
          label={T.translate(label)}
          to={to}
          containerId='scrollContainer'
        />
      </List>
    )

    return (
      <Layout theme={styles}>
        <NavDrawer pinned scrollY theme={styles}>
          <Heading>
            Navigation
          </Heading>
          {navigationListComponents}
        </NavDrawer>
        <Panel theme={styles}>
          <MainPanel/>
        </Panel>
      </Layout>
    )
  }
}

const withConnect = connect(mapStateToProps, mapDispatchToProps)
const withStyles = CSSModules(styles)
const withNvbugsSaga = injectSagas({ [NVBUGS]: nvbugsSagas })
const withNvbugsCardSaga = injectSagas({ [NVBUGS_CARD]: nvbugsCardSagas })
const enhance = compose(
  withConnect,
  withNvbugsCardSaga,
  withNvbugsSaga,
  withStyles
)

export default enhance(NvbugsPage)
